import React from 'react'
import { ProgressIcon } from '../../Components/LandingHeader/Feedback/icons/Icons'
import { generateArcPath } from '../../Components/action/utilities'

const TasksStatusWidget = ({taskStatus = null, direction = 'left', styles = {}, className = '', showLabel = true, width = 15, height = 15, totalTaskCount = null}) => {
    const endAngle = (taskStatus.completed / taskStatus.total) * 359

    return (
        !totalTaskCount ?
        null
        :
        <span className={`task-status-widget ${className}`} style={styles}>
            {direction === 'left' ? <ProgressIcon color={`var(--accent-color)`} width={width} height={height} pathd={generateArcPath(7.5, 7.5, 5.625, 0, endAngle)} /> : null}
            {showLabel && <span style={{lineHeight: "normal"}}><span className='darkPrimaryColor'>{taskStatus.completed}</span> <span className='total-count'>/ {totalTaskCount !== null ? totalTaskCount : taskStatus.total} Tasks done</span></span>}
            {direction === 'right' ? <ProgressIcon color={`var(--accent-color)`} width={width} height={height} pathd={generateArcPath(7.5, 7.5, 5.625, 0, endAngle)} /> : null}
        </span>
    )
}

export default TasksStatusWidget